export default "__VITE_ASSET__Mjfq2mxd__"